export default {
    breadcrumbs: {
        referrals: 'Referrals',
        received: 'from {name}',
        made: 'to {name}',
    },

    titles: {
        received: 'Request received from {designation} {name}',
        made: 'Request sent to {name}',
    },

    pool: {
        referrap_pool: {
            received: 'Referral received from ',
            made: 'Referral sent to {numberOfProviders} providers',
        },
    },

    notifications: {
        out_of_availability: 'This appointment is out of your actual availability.',
        patient_information_hidden: 'Patient information will be disclosed upon referral acceptance.',
        patient_information_disclaimer:
            'The following information will be disclosed after referred provider accepts the referral.',
    },

    buttons: {
        heading_cancel_reschedule: 'Please reschedule or cancel the referral',
        heading_decline_reschedule: 'Please reschedule or decline the referral',
        reschedule: 'Reschedule',
        decline: 'Decline',
        accept: 'Accept',
        cancel: 'cancel',
        _back: 'Back',
        back: 'BACK TO REFERRALS',
        update_status: 'UPDATE STATUS',
        rate_referral: 'RATE REFERRAL',
    },

    details: {
        patient_name: 'Patient name',
        request_sent: 'Request sucessfully sent',
        diagnosis: 'Diagnosis',
        specialty: 'Specialty required',
        insurance: 'Insurance',
        insurance_plan: 'Insurance plan',
        insurance_authorization_pending: 'Insurance authorization pending',
        insurance_authorization_declined: 'Insurance authorization declined',
        insurance_authorization_obtained: 'Insurance authorization obtained',
        insurance_authorization_status: 'Insurance authorization status',
        tests: 'Tests',
        insurance_authorization_statuses: {
            required: 'Required',
            not_required: 'Not required',
        },
        insurance_group_number: 'Insurance group #',
        insurance_number: 'Insurance #',
        location: 'Location',
        date_of_birth: 'Patient date of birth',
        service_required: 'Service required',
        physician_visit: 'provider visit',
        send_message_patient: 'Send message to patient:',
        referral_received: 'Referral received',
        declined: 'Declined',
        at: 'at',
        patient_visit: 'Patient visit pending',
        patient_seen: 'Patient seen',
        no_show: "Patient didn't show",
        appointment_cancelled: 'Appointment cancelled by {name}',
        cancelled_by_system: 'Appointment cancelled by the system',
        report_requested: 'Report requested on',
        solicit_again: 'Solicit report again',
        attachments: '{n} attachments',
        attachments_notes: '{n} Notes attachments',
        attachments_message: '{n} Message attachments',
        attachments_consultation: '{n} Consultation attachments',

        notice: {
            title: 'Attachment will be stored for 30 days.',
            action: 'Download Now!',
        },
    },

    confirmed: {
        heading: 'Appointment confirmed!',
        heading_successfully_rescheduled: 'Appointment successfully rescheduled!',
        button: 'View open referrals',
    },

    declined: {
        heading: 'Appointment {type}!',
        description: 'Appointment has been {type}.<br>Primary care provider and patient have been notified.',
        button: 'View open referrals',
    },

    cancellation: {
        referred: {
            title: 'Are you sure you want to cancel<br>appointment with patient {name}?',
            buttons: {
                yes: 'YES, CANCEL IT',
                no: 'NO, RESCHEDULE IT',
            },
        },
        referring: {
            title: 'Are you sure you want to cancel<br>referral for patient {name}?',
            buttons: {
                yes: 'YES, CANCEL IT',
                no: 'NO, REFER TO OTHERS',
            },
        },
    },

    add_notes: {
        buttons: {
            later: 'Do it later',
            finalize: 'finalize referral',
        },
    },

    decline_modal: {
        heading: 'Please indicate a reason for declining the referral',
        want_reschedule: 'Would you like to reschedule it?',
        type_message: 'Type message…',
        options: {
            slot_not_available: 'Slot not available',
            insurance_not_accepted: 'Not accepting patient insurance {name} anymore',
            service_not_available: 'Service {name} not available anymore',
            other: {
                value: 'Other',
                message: 'Please explain (Optional)',
            },
        },
        buttons: {
            decline: 'No, decline it',
            reschedule: 'Yes, please',
            done: 'Done',
        },
    },

    reschedule_modal: {
        heading: 'Please contact the patient to schedule a new appointment',
        orig_appointment_time: 'Original appointment time',
        agreed_new_appoinment: 'Do you have a new appointment?',
        roles: {
            physician: 'Referring Provider',
            patient: 'Patient',
        },
        buttons: {
            decline_referral: 'NO, DECLINE REFERRAL',
            cancel_referral: 'NO, CANCEL REFERRAL',
            update_schedule: 'YES, UPDATE SCHEDULE',
        },
    },

    reschedule_referral_new_modal: {
        heading: 'Please contact the patient for follow up visit',
        previous_appointment_time: 'Previous appointment Date & Time',
        agree_create_new_appointment: 'Do you want to create a follow up visit for the patient?',
        roles: {
            referring: 'Referring Provider',
            patient: 'Patient',
            referred: 'Referred To',
        },
        buttons: {
            cancel: 'NO',
            create_appointment: 'YES',
        },
    },

    upload_file_modal: {
        buttons: {
            choose: 'choose file',
            upload: 'upload file',
        },
    },

    insurance_modal: {
        title: 'Referral is pending insurance authorization. | Appointment is due in {n} hours',
        question: 'What is the insurance authorization status?',
        buttons: {
            not_obtained: 'NOT OBTAINED YET',
            declined: 'DECLINED',
            obtained: 'OBTAINED',
            done: 'DONE',
        },
        patient_insurance_plan: 'Patient insurance plan',
        heading_referred: 'Please contact primary care provider to obtain insurance authorization.',
        heading_reffering: 'Please contact the patient insurance company to obtain insurance authorization.',
    },

    insurance_auth_status: {
        reload_message: 'Please refresh the page to get the latest information.',
        status_updated: 'The status of this referral has already been updated to:',
        authorization_obtained: 'Authorization obtained',
        authorization_declined: 'Authorization declined',
    },

    disclaimer_modal: {
        heading: 'Caution',
        content:
            'By checking the box you agree to protect this electronic patient health information (ePHI) according to HIPAA Privacy Rule.',
        buttons: {
            cancel: 'CANCEL',
            continue: 'CONTINUE',
        },
    },

    view_details: {
        notes_uploaded: 'Consultation report uploaded',
        view_report: 'View report',
        consultation_notes: 'Consultation Report',
        pending_consultation_reports: 'Has Consultation Report Been Added ?',
        consultation_report_pending: 'Consultation Report pending',
        n_a: 'N/A',
        rating_not_available: 'Rating not available',
        rating_for: 'Patient rating for {name}',
        rating_for_new: 'Patient rating',
        rating_for_received: 'Patient rating for {name} received',
        my_rating_for: 'My rating for {name}',
        my_rating_for_new: 'My rating',
        my_rating_for_received: 'My rating for {name} received',
        referral_completed: 'Referral completed!',
        at: 'at',

        buttons: {
            add_report: 'ADD REPORT',
            request_report: 'REQUEST REPORT',
            view_details: 'View details',
            back: 'Back',
        },
    },
}
